import { combineReducers, createSlice } from '@reduxjs/toolkit';
import zonesSliceOptions from './zones';
import { interactiveResize } from '../../actions/actions';

const [fullscreen, orientation, width, height] = [
  ['fullscreen', false],
  ['orientation', 'landscape'],
  ['width', 0],
  ['height', 0],
].map(([name, initialState]) => sliceFactory(name, initialState));
const zonesSlice = createSlice(zonesSliceOptions);

const viewReducer = combineReducers({
  fullscreen: fullscreen.reducer,
  orientation: orientation.reducer,
  width: width.reducer,
  height: height.reducer,
  zones: zonesSlice.reducer,
});

export { viewReducer };

function sliceFactory(name, initialState) {
  return createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
      builder.addCase(interactiveResize, (state, action) => {
        return action.payload?.view?.[name] ?? state;
      });
    },
  });
}
